import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    minHeight: theme.spacing(5),
  },
  label: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  option: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
}))

export default styles
